<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <!--ricerca -->
        <div class="card-title pt-2 px-2">
          <div class="row">
            <div class="col-lg-10">
              <div class="d-lg-flex">
                <div class="flex-basis-40">
                  <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKey" (ngModelChange)="searchTask()" />
                </div>
                <!--filtro per il ruolo-->
                <div class="mx-lg-1 my-1 my-lg-0 flex-basis-30">
                  <ng-select id="role" [(ngModel)]="filter_role" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchTask()">
                    <ng-option [value]="-1">
                      <span class="font-small-4 font-weight-normal mr-1">{{ "ROLE" | translate }}</span>
                    </ng-option>
                    <ng-option *ngFor="let role of roles" [value]="role.id">
                      <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
                    </ng-option>
                  </ng-select>
                </div>
                <!--filtro per il gruppo--
                <div class="my-1 mr-lg-1 my-lg-0 flex-basis-30">
                  <ng-select id="figure" [(ngModel)]="filter_group" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchTask()">
                    <ng-option [value]="-1">
                      <span class="font-small-4 font-weight-normal mr-1">{{ "GROUP" | translate }}</span>
                    </ng-option>
                    <ng-option *ngFor="let group of groups" [value]="group.id">
                      <span class="font-small-4 font-weight-normal">{{ group.name }}</span>
                    </ng-option>
                  </ng-select>
                </div>
                !--filtro per lo priorità-->
                <div class="my-lg-0 flex-basis-30">
                  <ng-select id="priority" [(ngModel)]="filter_priority" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchTask()">
                    <ng-option [value]="-1">
                      <span class="font-small-4 font-weight-normal mr-1">{{ "PRIORITY" | translate }}</span>
                    </ng-option>
                    <ng-option *ngFor="let priority of priorities" [value]="priority">
                      <span class="font-small-4 font-weight-normal">{{ priority == 0 ? ("LOW" | translate) : priority == 1 ? ("MEDIUM_SINGULAR_FEMALE" | translate) : ("HIGH" | translate) }}</span>
                    </ng-option>
                  </ng-select>
                </div>
                <!--filtro per lo stato-->
                <div class="mx-lg-1 my-1 my-lg-0 flex-basis-30">
                  <ng-select id="status" [(ngModel)]="filter_status" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchTask()">
                    <ng-option [value]="-1">
                      <span class="font-small-4 font-weight-normal mr-1">{{ "STATE" | translate }}</span>
                    </ng-option>
                    <ng-option *ngFor="let state of status" [value]="state">
                      <span class="font-small-4 font-weight-normal">{{ state == 0 ? ("STATUS.TODO" | translate) : state == 1 ? ("STATUS.IN_PROGRESS" | translate) : ("STATUS.COMPLETED" | translate) }}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-md-2 text-lg-right" [ngClass.sm]="'d-none'">
              <div class="d-lg-flex justify-content-end">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
            </div>
          </div>
        </div>
        <!--desktop-->
        <div class="card-body p-0">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 60 : 150"
                         [limit]="tableLimit" [footerHeight]="50" [rows]="filterTasks" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
            <ngx-datatable-column [name]="'TITLE' | translate" prop="title" *ngIf="_utilService.isDesktop" width="450">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span [ngbTooltip]="row.description" placement="top">{{ row.title }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'INSERT_DATE' | translate" prop="insert_date" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span>{{ row.insert_date | date: 'dd/MM/yyyy' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CREATED_BY' | translate" prop="creator.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span>{{ row.creator.complete_name || ('THE_SYSTEM' | translate) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ROLE' | translate" prop="role_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span *ngIf="row.role_name == null">{{ "NO_ROLE" | translate }}</span>
                  <span *ngIf="row.role_name != null" [ngbTooltip]="row.users_names">{{ row.role_name }}</span>
              </ng-template>
            </ngx-datatable-column>
<!--            <ngx-datatable-column [name]="'GROUP' | translate" prop="group_name" *ngIf="_utilService.isDesktop">-->
<!--              <ng-template ngx-datatable-cell-template let-row="row">-->
<!--                  <span *ngIf="row.group_name == null">{{ "NO_GROUP" | translate }}</span>-->
<!--                  <span>{{ row.group_name }}</span>-->
<!--              </ng-template>-->
<!--            </ngx-datatable-column>-->
            <ngx-datatable-column [name]="'PRIORITY' | translate" prop="priority" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="badge" [class]="'badge-light-' + (row.priority == 0 ? 'secondary' : row.priority == 1 ? 'warning' : 'danger')">
                    {{ row.priority == 0 ? ("LOW" | translate) : row.priority == 1 ? ("MEDIUM_SINGULAR_FEMALE" | translate) : ("HIGH" | translate) }}
                  </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'STATE' | translate" prop="status" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="badge" [class]="'badge-light-' + (row.status == 0 ? 'secondary' : row.status == 1 ? 'warning' : 'success')">
                    {{ row.status == 0 ? ("STATUS.TODO" | translate) : row.status == 1 ? ("STATUS.IN_PROGRESS" | translate) : ("STATUS.COMPLETED" | translate) }}
                  </span>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'TITLE' | translate" prop="title" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12 text-truncate">
                    <span>{{ row.title }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ row.creator.complete_name }}</span>
                  </div>
                  <div class="col-6">
                    <span *ngIf="row.role_name == null">{{ "NO_ROLE" | translate }}</span>
                    <span>{{ row.role_name }}</span>
                  </div>
                  <div class="col-6">
                    <span *ngIf="row.group_name == null">{{ "NO_GROUP" | translate }}</span>
                    <span>{{ row.group_name }}</span>
                  </div>
                  <div class="col-6">
                    <span>{{ "PRIORITY" | translate }}: </span>
                    <span class="badge" [class]="'badge-light-' + (row.priority == 0 ? 'secondary' : row.priority == 1 ? 'warning' : 'danger')">
                      {{ row.priority == 0 ? ("LOW" | translate) : row.priority == 1 ? ("MEDIUM_SINGULAR_FEMALE" | translate) : ("HIGH" | translate) }}
                    </span>
                  </div>
                  <div class="col-6 pr-0">
                    <span>{{ "STATUS_LABEL" | translate }}: </span>
                    <span class="badge" [class]="'badge-light-' + (row.status == 0 ? 'secondary' : row.status == 1 ? 'warning' : 'success')">
                      {{ row.status == 0 ? ("STATUS.TODO" | translate) : row.status == 1 ? ("STATUS.IN_PROGRESS" | translate) : ("STATUS.COMPLETED" | translate) }}
                    </span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
